import axiosInstance from "../../_helpers/axiosInstance";
import config from "../../Config/config";
import {notificationConstants} from "../../_constants/User/notification.constants";

export const get_notification_action = () => async (dispatch) => {
    dispatch({
        type: notificationConstants.GET_NOTIFICATION_ACTION_REQUEST
    })
    try {
        const response = await axiosInstance.get(config.notification.getNotifications)
        if (response.status) {
            dispatch ({
                type: notificationConstants.GET_NOTIFICATION_ACTION_SUCCESS,
                payload: response.data
            })
            return response.data
        } else {
            return false
        }
    } catch (e) {
        dispatch({
            type: notificationConstants.GET_NOTIFICATION_ACTION_FAILURE,
            payload: e.msg
        })
    }
}